<template>
    <div class="ion-page">
        <ion-header>
          <ion-toolbar class="mobile-header-toolbar">
            <ion-buttons v-slot: start>
                <ion-back-button :default-href="'/cpoReport'" @click="navigatePreviousPage"></ion-back-button>
                <ion-title>Charger Fault Report</ion-title>
            </ion-buttons>
          </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
            <ChargerStatusReport />
        </ion-content>
    </div>
</template>
<script>
import { defineComponent } from "vue";
import ChargerStatusReport from "@/components/corporate/chargerStatusReport.vue";
import { IonButtons, IonBackButton, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar } from '@ionic/vue';

export default defineComponent({
    name:  'chargerStatusReport',
    components: {
        ChargerStatusReport,IonBackButton, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonContent
    },
    data() {
        return {

        }
    },
    methods: {
        navigatePreviousPage() {
            // Comment added by Sindhu, when navigate the page 2,3. go(-1) take page->3,2,1 like this 
            // this.$router.go(-1)
            this.$router.push("cpoReport")
        }
    }
})
</script>